import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { setReferralCode } from '../utils/referral';

export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) {
      navigate('/signup', { replace: true });
      return;
    }

    const cleanCode = code.trim().toUpperCase();

    const processReferral = async () => {
      try {
        setReferralCode(cleanCode);
        navigate(`/signup?refCode=${cleanCode}`, { replace: true });
      } catch (err) {
        console.error(err);
        setTimeout(() => {
          navigate('/signup', { replace: true });
        }, 2000);
      }
    };

    processReferral();
  }, [code, navigate]);

  return <div></div>;
}
